import React from "react";
import { useChatbot } from "../../searchAgent/chatBotContext";
import SearchAgentSuite from "./SearchAgentSuite";

/**
 * Simple wrapper component that manages visibility of the chat interface
 * This follows the container/presentational pattern by handling just the visibility logic
 */
const SocAiAgent: React.FC = () => {
  const { isVisible } = useChatbot();

  if (!isVisible) return null;
  
  return <SearchAgentSuite />;
};

export default SocAiAgent;